import { getPostLoginHomePath } from "util/v3UxConfig";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

export function isEligibleServicePaymentsExitHref(pathname) {
    return Boolean(pathname && pathname !== "/servicePayments");
}

/**
 * Destino coherente para "volver" desde subpantallas de pago de servicios (alineado con {@link ServicePaymentsMain}).
 *
 * @param {object} params
 * @param {string|null|undefined} params.moduleEntryPath Redux `servicePayments.moduleEntryPath`
 * @param {string|undefined|null} params.lastPathname p. ej. `status.lastHref.pathname`
 * @param {string} params.currentPathname `location.pathname` de la pantalla actual
 * @returns {string}
 */
export function resolveServicePaymentsExitHref({ moduleEntryPath, lastPathname, currentPathname }) {
    const homePath = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
    const pick = [moduleEntryPath, lastPathname].find(
        (p) => isEligibleServicePaymentsExitHref(p) && p !== currentPathname,
    );
    return pick || homePath;
}
